import { createContext, RefObject } from 'react';
import { Toast } from 'primereact/toast';

export type ToastContextType = RefObject<Toast> | null;

export const ToastContext = createContext<ToastContextType>(null);